// JavaScript Document

$(function(){


	/************************************************************
	MVアニメーション
	************************************************************/

	var slideNum = $('.bouquet_slide ul.bg li').length;

    //ループ機能

    //時間設定
    var interval = 3000;
	var current = 1;

	$(window).on('load', function(event) {
		var timer = setInterval(slideAnimation, interval);
	});

    function slideAnimation() {
		$('.bouquet_slide ul li:nth-child('+ current +')').removeClass('current');
		if(current == slideNum){
			current = 1;
		}else{
			current += 1;
		}
		$('.bouquet_slide ul li:nth-child('+ current +')').addClass('current');
    }


	/************************************************************
	商品拡大
	************************************************************/

	var showcase;

	$('.bouquet_showcase_list li').on('click', function(event) {
		event.preventDefault();
		showcase = $('img',this).attr('src');
		$('.bouquet_showcase img').attr('src', showcase);
		console.log(showcase);
	});

	/************************************************************
	PC-SP画像切り替え
	************************************************************/

	//切り替えポイント
	var rwdPoint=600;

	function ImgChange(){
		if($(window).width()<rwdPoint){
            $("img.rwd").each(function(){
				var changeImg = $(this).attr('src').replace('-pc.' , '-sp.');
				$(this).attr('src', changeImg);
			});
		}else{
			$("img.rwd").each(function(){
				var changeImg = $(this).attr('src').replace('-sp.' , '-pc.');
				$(this).attr('src', changeImg);
			});
		}
	}

	//読み込み時の処理
	ImgChange();

    //リサイズ時の処理
    $(window).resize(function () {
		ImgChange();
    });


});
